const ArrowUpIcon = ({ onClick, className = '' }) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      width="100%"
      height="100%"
      viewBox="0 0 8 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.94 5.66665L4 2.3702L7.06 5.66665L8 4.6518L4 0.333313L0 4.6518L0.94 5.66665Z"
        fill="#747985"
      />
    </svg>
  );
};

export default ArrowUpIcon;
